export const cyan = {
  1: { value: { base: '{colors.cyan.light.1}', _dark: '{colors.cyan.dark.1}' } },
  2: { value: { base: '{colors.cyan.light.2}', _dark: '{colors.cyan.dark.2}' } },
  3: { value: { base: '{colors.cyan.light.3}', _dark: '{colors.cyan.dark.3}' } },
  4: { value: { base: '{colors.cyan.light.4}', _dark: '{colors.cyan.dark.4}' } },
  5: { value: { base: '{colors.cyan.light.5}', _dark: '{colors.cyan.dark.5}' } },
  6: { value: { base: '{colors.cyan.light.6}', _dark: '{colors.cyan.dark.6}' } },
  7: { value: { base: '{colors.cyan.light.7}', _dark: '{colors.cyan.dark.7}' } },
  8: { value: { base: '{colors.cyan.light.8}', _dark: '{colors.cyan.dark.8}' } },
  9: { value: { base: '{colors.cyan.light.9}', _dark: '{colors.cyan.dark.9}' } },
  10: { value: { base: '{colors.cyan.light.10}', _dark: '{colors.cyan.dark.10}' } },
  11: { value: { base: '{colors.cyan.light.11}', _dark: '{colors.cyan.dark.11}' } },
  12: { value: { base: '{colors.cyan.light.12}', _dark: '{colors.cyan.dark.12}' } },
  a1: { value: { base: '{colors.cyan.light.a1}', _dark: '{colors.cyan.dark.a1}' } },
  a2: { value: { base: '{colors.cyan.light.a2}', _dark: '{colors.cyan.dark.a2}' } },
  a3: { value: { base: '{colors.cyan.light.a3}', _dark: '{colors.cyan.dark.a3}' } },
  a4: { value: { base: '{colors.cyan.light.a4}', _dark: '{colors.cyan.dark.a4}' } },
  a5: { value: { base: '{colors.cyan.light.a5}', _dark: '{colors.cyan.dark.a5}' } },
  a6: { value: { base: '{colors.cyan.light.a6}', _dark: '{colors.cyan.dark.a6}' } },
  a7: { value: { base: '{colors.cyan.light.a7}', _dark: '{colors.cyan.dark.a7}' } },
  a8: { value: { base: '{colors.cyan.light.a8}', _dark: '{colors.cyan.dark.a8}' } },
  a9: { value: { base: '{colors.cyan.light.a9}', _dark: '{colors.cyan.dark.a9}' } },
  a10: { value: { base: '{colors.cyan.light.a10}', _dark: '{colors.cyan.dark.a10}' } },
  a11: { value: { base: '{colors.cyan.light.a11}', _dark: '{colors.cyan.dark.a11}' } },
  a12: { value: { base: '{colors.cyan.light.a12}', _dark: '{colors.cyan.dark.a12}' } },
}
